import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from './modal.service';

@Component({
  selector: 'atlas-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponent {
  @Input() width: number | string;
  @Input() height: number | string;
  @Input() maxHeight: number | string;
  public isMobile$: Observable<boolean>;

  constructor(private modalService: ModalService) {
    this.isMobile$ = this.modalService.mobile$;
  }

  get widthStyle(): string {
    if (this.width === null || typeof this.width === 'undefined') {
      return 'inherit';
    }
    if (typeof this.width === 'number') {
      return this.width + 'px';
    }
    return this.width;
  }

  get heightStyle(): string {
    if (this.height === null || typeof this.height === 'undefined') {
      return 'inherit';
    }
    if (typeof this.height === 'number') {
      return this.height + 'px';
    }
    return this.height;
  }

  get maxHeightStyle(): string {
    if (this.maxHeight === null || typeof this.maxHeight === 'undefined') {
      return 'inherit';
    }
    if (typeof this.maxHeight === 'number') {
      return this.maxHeight + 'px';
    }
    return this.maxHeight;
  }
}
